export default "__VITE_ASSET__ubCIrq2T__"